import { render, staticRenderFns } from "./DossierActionConfirmDialog.vue?vue&type=template&id=4261062e&scoped=true"
import script from "./DossierActionConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./DossierActionConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./DossierActionConfirmDialog.vue?vue&type=style&index=0&id=4261062e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261062e",
  null
  
)

export default component.exports